<script>

import LoginModal from "@/components/login-modal";
import axios from "axios";
import config from "@/config.json";
import {post} from "@/assets/js/utils";
import {fetchUser, isUnauthenticated} from "@/assets/js/auth-store";

export default {
  props: {
    type: {
      type: Number,
      default: 1
    },
    pricingData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      selected: 0,
      // 下单用的 type 必须和控制版式的 type prop 分开。
      // 以前两者重名，Vue 会跳过 data 定义、让 this.type = type 直接改到 prop 上，
      // 于是点一下 Buy 就把 prop 从 1 改成 0，v-if="type === 1" 失效，整排价格卡片当场消失。
      orderType: 0,
      orderError: ""
    };
  },
  methods: {
    async onBuy(skuId, type) {
      this.selected = skuId;
      this.orderType = type;
      this.orderError = "";
      // 走共享的登录态：服务端 3 秒内的重复请求会 429，
      // 刚进页面导航栏已经查过一次，这里再查一次必被挡。
      const me = await fetchUser();
      // 只有服务端明确说「未登录」才弹登录框。
      // 429 / 5xx / 断网这类没有结论的失败照常往下走，真正的鉴权由下单接口自己完成，
      // 否则一次网络抖动就会让已登录的用户被要求重新登录。
      if (isUnauthenticated(me)) {
        this.$bvModal.show("login-modal");
        return;
      }
      await this.createOrder();
    },
    async createOrder() {
      this.orderError = "";
      const data = await post(`${config.api.neworder}`, {sku_id: this.selected, type: this.orderType});
      if (data && data.errno === 0 && data.data) {
        await this.$router.push('/shop-cart?order_id=' + data.data.order_id);
        return;
      }
      if (isUnauthenticated(data)) {
        this.$bvModal.show("login-modal");
        return;
      }
      // 以前这里是空的（只有一句 TODO），下单失败用户点了按钮完全没反应，
      // 连开发者也看不出发生了什么。至少要把服务端给的原因显示出来。
      this.orderError = (data && data.info) || "";
    }
  },
  components: {
    LoginModal
  }
};
</script>

<template>
  <div>
    <login-modal @onLoginSuccess="createOrder"/>
    <div class="alert alert-danger mt-4" role="alert" v-if="orderError">{{ orderError }}</div>

    <div class="row" v-if="type === 1">
      <div class="col-md-3 col-12 mt-4 pt-2" v-for="(item, index) of pricingData" :key="index" >
        <div class="card pricing-rates business-rate shadow bg-light rounded text-center border-0" >
          <div class="ribbon ribbon-right ribbon-warning overflow-hidden" v-if="item.isBest === true" >
            <span class="text-center d-block shadow small h6">Best</span>
          </div>

          <div class="card-body py-5">
            <h6 class="title font-weight-bold text-uppercase text-primary mb-4">
              {{ item.title }}
            </h6>
            <div class="d-flex justify-content-center mb-4">
              <span class="h4 mb-0 mt-2">{{item.currency}}</span>
              <span class="price h1 mb-0">{{ item.price }}</span>
              <span class="h4 align-self-end mb-1">{{item.period}}</span>
            </div>

            <ul class="list-unstyled mb-0 pl-0">
              <li class="text-muted mb-0" v-for="(feature, index) in item.feature" :key="index" >
                <span class="text-primary mr-2"><i class="uil uil-check-circle align-middle"></i></span >
                {{ feature }}
              </li>
            </ul>
            <a href="#" @click.prevent="onBuy(item.sku_id, item.type)" class="btn btn-primary mt-4">{{ item.button }}</a>
          </div>
        </div>
      </div>

    </div>

    <div class="row align-items-center mt-5" v-if="type === 2">
      <div class="col-lg-5 col-md-6">
        <img width="700" height="881" loading="lazy" src="/images/hosting/1.png" class="img-fluid" :alt="$t('alt.pricing')" />
      </div>
      <!--end col-->

      <div class="col-lg-7 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
        <div class="section-title ml-lg-5">
          <h2 class="h4 title mb-4"> {{$t('index.price.enterprise.title')}} </h2>
          <p> {{$t('index.price.enterprise.description')}} </p>
          <p> {{$t('index.price.enterprise.price')}} </p>
          <ul class="list-unstyled text-muted">
            <li class="mb-0" v-for="item in $t('index.price.enterprise.feature')">
                  <span class="text-primary h5 mr-2"
                  ><i class="uil uil-check-circle align-middle"></i></span>
              {{item}}
            </li>
          </ul>
          <a href="#" @click.prevent="onBuy(21, 0)" class="btn btn-primary mt-3">{{$t('index.price.enterprise.button')}} <i class="mdi mdi-chevron-right"></i
          ></a>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
</template>
